import PicklistMetadata from "../PicklistMetadata";

// The 'Connection Dialect' list of values: which SQL a connection's rules compile into.
//
// Flat, unlike ConnectionType. These are the dialects the COMPILER implements, not database
// products -- one of them covers several products, and there is no family to nest them under.
//
// Normally left blank. A connection type almost always settles the dialect, and this exists for the
// case where it cannot: a transport such as Arrow Flight SQL says how to reach the server, and what
// is behind it decides the SQL.
class ConnectionDialectPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ConnectionDialect";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Connection Dialect";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.hierarchical = false;
        // Blank is the normal answer, so it has to be selectable -- otherwise a connection that
        // picked a dialect by accident could never go back to letting its driver decide.
        this.allowNoSelection = true;
    }
}

export default ConnectionDialectPicklistMetadata;
